import { ReactNode, useRef } from 'react';
import ComplexTooltip from '../Tooltip/ComplexTooltip';
import { IFacetAlert } from '@/@types/client-api';
import Button from '../Buttons/Button';

interface FacetAlertTooltipProps {
  onClearFilters: () => void;
  onClose: () => void;
  tooltipData: IFacetAlert;
  children: ReactNode;
}
const FacetAlertTooltip = ({
  onClearFilters,
  onClose,
  tooltipData,
  children
}: FacetAlertTooltipProps) => {
  const customContainerRef = useRef<HTMLDivElement>(null);

  const handleClearFilter = () => {
    onClearFilters();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div ref={customContainerRef}>
      <ComplexTooltip isOpen={true}>
        <ComplexTooltip.Trigger asChild>{children}</ComplexTooltip.Trigger>

        <ComplexTooltip.Content customContainer={customContainerRef.current} onClose={handleClose}>
          <div className="text-2">
            <p className="mb-4" dangerouslySetInnerHTML={{ __html: tooltipData.title || '' }} />
            <p
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: tooltipData.description || '' }}
            />
            <div className="flex justify-between gap-4">
              <Button
                onClick={handleClearFilter}
                className={'w-full justify-center'}
                color="outline-black"
                label={tooltipData.ctaBtnLabel || ''}
                size={'small'}
              />
              <Button
                onClick={handleClose}
                className={'w-full justify-center'}
                color="outline-black"
                label={tooltipData.dismissBtnLabel || ''}
                size={'small'}
              />
            </div>
          </div>
        </ComplexTooltip.Content>
      </ComplexTooltip>
    </div>
  );
};

export default FacetAlertTooltip;
